
import './App.css';
import { BrowserRouter, Routes, Route, Switch, Navigate } from 'react-router-dom';
import Home from './Components/Home.js';
import ProtectedRoutes from './Components/Utils/ProtectedRoutes.jsx';
import Login from './Components/Login.js';
import { AuthProvider } from './Components/Utils/Auth.js';
import Admin from './Components/AdminPage/Admin.js';
import ProtectedAdminRoute from './Components/Utils/ProtectedAdminRoute.jsx';

function App() {
  return (
  <AuthProvider>
      <Routes>
        
        <Route  path='/login' exact element={<Login/>}></Route>
        <Route element={<ProtectedRoutes/>}>
          <Route path='/'  element={<Home/>} ></Route>
        </Route>
        <Route element={<ProtectedAdminRoute/>}>
          <Route path='/Admin' element={<Admin/>}  ></Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
  </AuthProvider>
  
    
  );
}

export default App;
